import { memo } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { convertToBooleanSwitch } from "util/transformers";
import { useTypedSelector } from "hooks";
import { selectIsMerchantLoading } from "features/merchants/selectors";
import { createOrUpdateMerchantSettings } from "features/merchants/api";
import type { MerchantResponse } from "features/merchants/types";
import useMerchantActions from "features/merchants/useMerchantActions";
import { StatusResourceTableCell } from "../../../shared/TableCells";

const MerchantModeLive = (props: GridRenderCellParams) => {
    const { putMerchant } = useMerchantActions();

    const isProcessing = useTypedSelector(selectIsMerchantLoading);

    const handleProcess = async (isChecked: boolean, { row }: GridRenderCellParams) => {
        const isLiveMode = convertToBooleanSwitch(isChecked);

        const [response] = putMerchant({
            coreId: row.coreId,
            isLiveMode
        });

        Promise.allSettled([
            createOrUpdateMerchantSettings({
                coreId: row.merchantSettingCoreId,
                merchantId: row.coreId,
                isLiveMode
            }),
            response
        ]);

        return response as Promise<MerchantResponse>;
    };

    const getChecked = ({ value }: GridRenderCellParams) => !!Number(value);

    const getTransitionStatus = () => {
        if (getChecked(props)) {
            return 'stop';
        }

        return 'enable';
    };
    const getTransitionDirection = () => {
        if (getChecked(props)) {
            return 'from';
        }

        return 'for';
    };
    const defaultDialogContent = {
        dialogContent: [
            `Are you sure you want to ${getTransitionStatus()} this merchant ${getTransitionDirection()} Live traffic ?`
        ],
        actionContent: 'Yes'
    };

    return (
        <StatusResourceTableCell
            {...props}
            isProcessing={isProcessing}
            getChecked={getChecked}
            handleProcess={handleProcess}
            dialogContentDescription={defaultDialogContent}
        />
    );
};

export default memo(MerchantModeLive);
